import {asyncLoad} from '.';

export const loadCountries = () => dispatch =>
  asyncLoad({
    dispatch,
    params: {includePortal: false},
    title: 'countries',
    url: '/address/countries',
  });

export const loadStates = () => dispatch =>
  asyncLoad({
    dispatch,
    params: {includePortal: false},
    title: 'states',
    url: '/address/states',
  });



// WEBPACK FOOTER //
// ./src/actions/addressActions.js